module.exports = __webpack_public_path__ + "assets/img/00027.3db8d4da.png";